import { IntegrationsAgreggatedSyncableStateValuesEnum } from 'generated/resources/datatable.graphql'
import { CompensationsValueObjectsEmployeeStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const VALID_EMPLOYEE_STATUSES: readonly CompensationsValueObjectsEmployeeStatusEnum[] = [
  'active',
  'inactive_this_month',
  'inactive_last_3_months',
] as const

export type CompensationsFilters = {
  legalEntityIds?: number[]
  teamIds?: number[]
  workplaceIds?: number[]
  validationTypes?: string[]
  integrationsAgreggatedSyncableStates?: string[]
  employeeStatus?: CompensationsValueObjectsEmployeeStatusEnum[]
}

export const syncStatusFilterConfig = () => {
  const options: Record<IntegrationsAgreggatedSyncableStateValuesEnum, string> = {
    synced: i18n.t('integrations.filters.sync_status.synced'),
    partially_synced: i18n.t('integrations.filters.sync_status.partially_synced'),
    outdated: i18n.t('integrations.filters.sync_status.outdated'),
    failed: i18n.t('integrations.filters.sync_status.failed'),
    pending: i18n.t('integrations.filters.sync_status.pending'),
  }

  return {
    integrationsAgreggatedSyncableStates: {
      label: i18n.t('integrations.filters.sync_status.sync_status_label'),
      type: 'in' as const,
      options: {
        options: Object.entries(options).map(([value, label]) => ({
          label,
          value,
        })),
      },
    },
  }
}

export const employeeStatusFilterConfig = () => {
  const options: Record<CompensationsValueObjectsEmployeeStatusEnum, string> = {
    active: i18n.t('compensations.PayrollRunCompensationsList.filters.employeeStatusActive'),
    inactive_this_month: i18n.t(
      'compensations.PayrollRunCompensationsList.filters.employeeStatusInactiveThisMonth'
    ),
    inactive_last_3_months: i18n.t(
      'compensations.PayrollRunCompensationsList.filters.employeeStatusInactiveLast3Months'
    ),
  }

  return {
    employeeStatus: {
      label: i18n.t('compensations.PayrollRunCompensationsList.filters.employeeStatusLabel'),
      type: 'in' as const,
      options: {
        options: Object.entries(options).map(([value, label]) => ({
          label,
          value,
        })),
      },
    },
  }
}
